import { createErrorMessageId } from '../helpers';
import { DeepReadOnly, ValidationMessageType, ValidationMessageTypeSeverity } from '../types';
import stringTider from '../utils/stringTider';

// from: smpackages/packages/logging/src/DevFormatter.ts
/**
 * Hashes a string into a number
 * @param {string} s Input string
 * @returns {number} hashed value
 */
function hashCode(s: string): number {
  return s.split('').reduce((a, b) => {
    // eslint-disable-next-line no-param-reassign, no-bitwise
    a = (a << 5) - a + b.charCodeAt(0);
    // eslint-disable-next-line no-bitwise
    return a & a;
  }, 0);
}

export default (
  message: string,
  id?: string | null,
  type?: ValidationMessageTypeSeverity,
  field?: string
): DeepReadOnly<ValidationMessageType> => {
  // strip whitespace
  const parsedId = stringTider(id) || `msg#${hashCode(message)}`;
  const parsedMessage = stringTider(message);

  if (!parsedMessage) {
    throw new Error(createErrorMessageId('missing validation message'));
  }

  return Object.freeze(<ValidationMessageType>{
    id: parsedId,
    message: parsedMessage,
    type: type ?? 'warn',
    field: field ?? null,
  });
};
